import { createAction, props } from '@ngrx/store';

import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';
import { LocalidadIDE } from './entity-localidades-ide.model';

export const entityLocalidadesIDELoadRequest = createAction(
  '[ENTITYLOCALIDADESIDE] Load Request',
  props<{ q: string }>()
);

export const entityLocalidadesIDELoadFailure = createAction(
  '[ENTITYLOCALIDADESIDE] Load Failure',
  props<{ error: Error }>()
);

export const entityLocalidadesIDELoadSuccess = createAction(
  '[ENTITYLOCALIDADESIDE] Load Success',
  props<{ items: LocalidadIDE[] }>()
);
